import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLString,
  GraphQLID
} from 'graphql'
import { dateTimeType, DateTime } from './date-time-type'

export interface LibraryUsageItem {
  readonly id: string
  readonly name: string
  readonly firstSeen: DateTime
  readonly lastSeen: DateTime
}

export const libraryClassUsageItemType = new GraphQLObjectType({
  name: 'LibraryClassUsageItem',
  fields: () => ({
    id: {
      description: 'A unique identifier for the library usage item',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'The name of the file or class',
      type: new GraphQLNonNull(GraphQLString)
    },
    firstSeen: {
      description: 'The first time that the file or class was reported',
      type: dateTimeType
    },
    lastSeen: {
      description: 'The last time that the file or class was reported',
      type: dateTimeType
    }
  })
})
